import BgGradient from '@webclient/components/bg-gradient';

import Toolbar from '@webclient/layouts/main/sections/toolbar';
import {
  StyledInnerStack,
  StyledWrapperStack,
} from '@webclient/layouts/main/styles';

export default function MainLayout({ children }: React.PropsWithChildren) {
  return (
    <StyledWrapperStack>
      <StyledInnerStack>
        <BgGradient aria-hidden />
        <Toolbar>{children}</Toolbar>
      </StyledInnerStack>
    </StyledWrapperStack>
  );
}
